import { getMLLatestCost, caclAllML, caclOneML, getMLLatestCostDetail } from '@/api/caclMLCost'
import Vue from 'vue'

const state = {
  mlLatestCostList: [],
  currentMLLatestCost: {},
}

const actions = {
  async getMLLatestCostAction({ commit }, payload) {
    try {
      const res = await getMLLatestCost(payload)
      commit('GET_ML_LATEST_COST', res.data)
      return res.data
    } catch (error) {
      throw error
    }
  },
  async getMLLatestCostDetailAction({ commit }, payload) {
    try {
      const res = await getMLLatestCostDetail(payload)
      commit('GET_ML_LATEST_COST_Detail', res.data)
      return res.data
    } catch (error) {
      throw error
    }
  },
  async caclAllMLAction({ commit }, payload) {
    try {
      await caclAllML(payload)
    } catch (error) {
      throw error
    }
  },

  async caclOneMLAction({ commit }, payload) {
    try {
      await caclOneML(payload)
    } catch (error) {
      throw error
    }
  },
}

const mutations = {
  GET_ML_LATEST_COST(state, payload) {
    state.mlLatestCostList = payload.materialList
  },
  GET_ML_LATEST_COST_Detail(state, payload) {
    state.currentMLLatestCost = payload
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}